import React from 'react';

const InventoryTabContext = React.createContext();

export default InventoryTabContext;
